// extracted by mini-css-extract-plugin
export var cancelButton = "_ma-5";
export var content = "_ma-3";
export var createButton = "_ma-6";
export var drawerContainer = "_ma-0";
export var footer = "_ma-2";
export var header = "_ma-1";
export var orderFormColumn = "_ma-4";